import React from 'react';
import AddHeader from '../../../../components/layout/header/add';
import Forms from '../../../../components/molecules/forms';
import FormFooter from '../../../../components/layout/footer/form';
import { LineStroke, Pencil } from '../../../../components/atoms/icons';
import useAddWarehouse from './hooks';

function AddWarehouse() {
  const {
    formik, state, warehouse, isEdit, submitLoad,
  } = useAddWarehouse();

  const renderButtonEdit = React.useMemo(() => (
    <button
      type="button"
      onClick={() => isEdit.setCurrent(true)}
      className={!!warehouse.id && !isEdit.current ? 'bg-transparent border-0' : 'd-none'}
    >
      <Pencil color="black" width={18} />
    </button>
  ), [warehouse.id && !isEdit.current]);

  return (
    <div>
      <AddHeader
        primary={{
          route: '/warehouse',
          title: warehouse.data?.name ?? 'Add Warehouse',
        }}
        title={warehouse.data?.name ?? 'Add Warehouse'}
        topRightItem={renderButtonEdit}
      />
      <form onSubmit={formik.handleSubmit}>
        <div className="px-4 px-xl-5">
          <Forms.Default
            id="name"
            placeholder="Enter Warehouse Name"
            label="Warehouse Name"
            className="mb-4"
            value={formik.values.name}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.name && formik.touched.name}
            errorMsg={formik.errors.name}
            onBlur={formik.handleBlur}
            disabled={warehouse.load}
            readOnly={!!warehouse.id && !isEdit.current}
          />
          <Forms.Default
            id="streetAddress"
            placeholder="Enter Address"
            label="Address"
            className="mb-4"
            value={formik.values.streetAddress}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.streetAddress && formik.touched.streetAddress}
            errorMsg={formik.errors.streetAddress}
            onBlur={formik.handleBlur}
            disabled={warehouse.load}
            readOnly={!!warehouse.id && !isEdit.current}
          />
          <Forms.Default
            id="city"
            placeholder="Enter City"
            label="City"
            className="mb-4"
            value={formik.values.city}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.city && formik.touched.city}
            errorMsg={formik.errors.city}
            onBlur={formik.handleBlur}
            disabled={warehouse.load}
            readOnly={!!warehouse.id && !isEdit.current}
          />
          <Forms.ReactSelect.Default
            id="state"
            placeholder="Enter State"
            label="State"
            className="mb-4"
            isSearchable={false}
            options={state.list}
            value={state.list.find((x) => x.value === formik.values.state)}
            onChange={(e) => {
              if (e && !(!!warehouse.id && !isEdit.current)) {
                formik.setFieldValue('state', e.value);
              }
            }}
            isInvalid={!!formik.errors.state && formik.touched.state}
            errorMsg={formik.errors.state}
            onBlur={formik.handleBlur}
            disabled={warehouse.load}
          />
          <Forms.Default
            id="zipCode"
            placeholder="Enter Zip"
            label="Zip"
            className="mb-4"
            type="number"
            value={formik.values.zipCode}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.zipCode && formik.touched.zipCode}
            errorMsg={formik.errors.zipCode}
            onBlur={formik.handleBlur}
            disabled={warehouse.load}
            readOnly={!!warehouse.id && !isEdit.current}
          />
        </div>
        {((!!warehouse.id && isEdit.current) || !warehouse.id) && (
        <div>
          <LineStroke height={7} />
          <FormFooter
            cancelText="Cancel"
            submitText={isEdit.current && !!warehouse.id ? 'Edit Warehouse' : 'Add Warehouse'}
            isLoading={warehouse.load || submitLoad}
          />
        </div>
        )}
      </form>
    </div>
  );
}

export default AddWarehouse;
